var map = {
	"./QRcode.png": "6328",
	"./about-1.png": "b240",
	"./about-2.png": "ca08",
	"./about-3.png": "2523",
	"./activity/legal.png": "ccef",
	"./activity/news.png": "f103",
	"./banner/banner-1.png": "9fdb",
	"./banner/banner-2.png": "3204",
	"./beian.png": "7796",
	"./bg/contact-form.png": "bd65",
	"./bg/layout.png": "e357",
	"./bg/section-1.png": "89ed",
	"./bg/section-2.png": "eba6",
	"./bg/section-3.png": "a1a5",
	"./bg/section-4.png": "426e",
	"./contact.png": "dfe7",
	"./home-about.png": "cc5a",
	"./logo-footer.png": "6331",
	"./logo-header.png": "fcc2",
	"./service/contract_dispute.png": "0773",
	"./service/criminal_case.png": "85fc",
	"./service/debt_dispute.png": "95a8",
	"./service/enterprise_legal.png": "324f",
	"./service/family_affairs.png": "3533",
	"./service/intellectual_property.png": "21f9",
	"./service/non_litigation.png": "2710",
	"./service/other.png": "2672",
	"./top-image.png": "b4db",
	"./top-image_en.png": "92de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";